
import { defineComponent } from 'vue'
import { useKpis } from '../../../composables/use-kpis'
import { SteppedAnimationMixin } from '../../../mixins/stepped-animation.mixin'
import FunnelChart from './funnel-chart.component.vue'
import SteppedKpisBar from './stepped-kpis-bar.component.vue'

export default defineComponent({
  name: 'KpisSuccess',
  components: {
    FunnelChart,
    SteppedKpisBar,
  },
  mixins: [SteppedAnimationMixin],
  props: {
    selectedId: String,
  },
  setup() {
    const { supportedKpis } = useKpis()
    return {
      supportedKpis,
    }
  },
  data() {
    return {
      animationStepDurationsInMillis: [
        SteppedAnimationMixin.data().animationStepDurationsInMillis[0],
        SteppedAnimationMixin.data().animationStepDurationsInMillis[1] +
          SteppedAnimationMixin.data().animationStepDurationsInMillis[2],
      ],
    }
  },
  computed: {
    kpisSuccessItemProps() {
      return {
        height: 140,
        selectedId: this.selectedId,
        animationStepDurationsInMillis: this.animationStepDurationsInMillis,
        currentAnimationStep: this.currentAnimationStep,
        kpis: this.supportedKpis,
        showAsides: true,
      }
    },
  },
})
